import { useTranslate } from "@similarweb/i18n-provider";
import { Box } from "@similarweb/ui-components/foundations";

import useCurrentStateAndParamsWithFixedDomain from "app/pages/sales-intelligence/modules/company-analysis/hooks/useCurrentStateAndParamsWithFixedDomain";
import useCompanyCardQuery from "app/pages/sales-intelligence/modules/company-analysis/queries/useCompanyCardQuery";
import salesSettingsHelper from "app/pages/sales-intelligence/services/salesSettingsHelper";

import { ConversionRateUpgradeBanner } from "../../../components/cards/company-card/ConversionRateBanner/ConversionRateUpgradeBanner";
import { ReportEcommerce } from "../../../components/ReportEcommerce/ReportEcommerce";
import Card from "../../../components/shared/Card/Card";
import CardHeader from "../../../components/shared/Card/CardHeader/CardHeader";

import { CompanyDataBody } from "./CompanyDataBody";
import { Skeleton } from "./Skeleton";

const CompanyData = () => {
    const { translate } = useTranslate();

    const isEcommConversionRateEnabled = salesSettingsHelper.isEcommConversionRateEnabled;

    const { params } = useCurrentStateAndParamsWithFixedDomain();
    const domain = params.key;

    const { data, isLoading, isFetched } = useCompanyCardQuery();
    const isEmpty = !data && isFetched;

    return (
        <Card
            dataAutomation="company-data"
            isLoading={isLoading}
            loader={<Skeleton />}
            isEmpty={isEmpty}
            header={<CardHeader title={translate("si.company-analysis.company-data.card.header")} />}
            renderContent={() => (
                <>
                    {data ? (
                        <CompanyDataBody
                            data={data}
                            isEcommConversionRateEnabled={isEcommConversionRateEnabled}
                        />
                    ) : null}

                    {isFetched && data && !data.isEcommerceSite ? (
                        <ReportEcommerce
                            isAlreadyReported={data.isReported}
                            domain={domain}
                        />
                    ) : null}

                    {data?.isEcommerceSite && !isEcommConversionRateEnabled ? (
                        <Box margin="0 8px 8px 8px">
                            <ConversionRateUpgradeBanner />
                        </Box>
                    ) : null}
                </>
            )}
        />
    );
};

export default CompanyData;
